import { render, staticRenderFns } from "./ModalContractTemplateRemark.vue?vue&type=template&id=61149838&"
import script from "./ModalContractTemplateRemark.vue?vue&type=script&lang=js&"
export * from "./ModalContractTemplateRemark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports